"use client";

import React from "react";
import { Sparkles, PiggyBank, Zap, Target, ArrowUpRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurPhilosophy() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const box1Reveal = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const box2Reveal = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const box3Reveal = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="130956" id="our-patient-promise" className="dark bg-background text-foreground py-24 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerReveal.ref} className={`mb-16 max-w-2xl transition-all duration-1000 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-primary font-mono text-sm tracking-widest uppercase mb-4 flex items-center gap-2">
            <Sparkles className="size-4" />
            Our Patient Promise
          </h2>
          <p className="text-4xl md:text-6xl font-serif font-bold tracking-tight leading-[1.1] text-foreground">
            Healthcare, rooted in <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
              community.
            </span>
          </p>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed font-sans">
            At Freetown Family Clinic, we believe every family deserves access to high-quality medical care that is compassionate, culturally aware, and affordable for our neighbors.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[minmax(250px,auto)]">
          
          {}
          <div ref={box1Reveal.ref} className={`md:col-span-2 md:row-span-2 transition-all duration-1000 delay-100 ${box1Reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <Card className="h-full bg-card/60 backdrop-blur-md border-primary/20 relative overflow-hidden group hover:border-primary/40 transition-colors duration-500 rounded-3xl">
              {}
              <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/10 rounded-full blur-[100px] pointer-events-none group-hover:bg-primary/20 transition-colors duration-700" />
              
              <CardHeader className="pb-0 pt-10 px-10 relative z-10">
                <div className="size-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 border border-primary/20">
                  <Sparkles className="size-7 text-primary" />
                </div>
                <CardTitle className="text-5xl md:text-7xl font-serif font-bold tracking-tight mb-4">
                  Culture.
                </CardTitle>
              </CardHeader>
              <CardContent className="px-10 pb-10 relative z-10 flex flex-col justify-between h-[calc(100%-180px)]">
                <p className="text-xl md:text-2xl text-muted-foreground font-sans font-medium leading-relaxed max-w-lg">
                  We understand the diverse cultures of our patient population. Our staff provides care that respects your culture and heritage.
                </p>
                <div className="mt-12 flex items-center gap-3 text-primary font-mono font-semibold tracking-wide uppercase text-sm">
                  <span>Inclusive Care</span>
                  <ArrowUpRight className="size-5" />
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={box2Reveal.ref} className={`md:col-span-1 transition-all duration-1000 delay-200 ${box2Reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <Card className="h-full bg-gradient-to-br from-card to-secondary/10 border-secondary/20 hover:border-secondary/40 transition-colors duration-500 relative overflow-hidden rounded-3xl">
               <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-secondary/10 rounded-full blur-[80px] pointer-events-none" />
              <CardHeader className="pt-8 px-8">
                <div className="size-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-4 border border-secondary/20">
                  <PiggyBank className="size-6 text-secondary" />
                </div>
                <CardTitle className="text-3xl font-serif font-bold tracking-tight mb-2">
                  Affordability.
                </CardTitle>
              </CardHeader>
              <CardContent className="px-8 pb-8">
                <p className="text-muted-foreground font-sans leading-relaxed">
                  Quality healthcare should never be out of reach. We offer flexible payment options and community programs to ensure wellness for all families in our district.
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={box3Reveal.ref} className={`md:col-span-1 transition-all duration-1000 delay-300 ${box3Reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <Card className="h-full bg-gradient-to-tr from-card to-chart-3/10 border-chart-3/20 hover:border-chart-3/40 transition-colors duration-500 relative overflow-hidden rounded-3xl">
              <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-chart-3/10 via-transparent to-transparent pointer-events-none" />
              <CardHeader className="pt-8 px-8">
                <div className="size-12 rounded-xl bg-chart-3/10 flex items-center justify-center mb-4 border border-chart-3/20">
                  <Target className="size-6 text-chart-3" />
                </div>
                <CardTitle className="text-3xl font-serif font-bold tracking-tight mb-2">
                  Attention.
                </CardTitle>
              </CardHeader>
              <CardContent className="px-8 pb-8">
                <p className="text-muted-foreground font-sans leading-relaxed">
                  You are more than a patient; you are family. We take the time to listen and build long-term health partnerships with every generation of your household.
                </p>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}